export default __webpack_public_path__ + "static/media/BootsSharp-Bold.fd61e1ab.woff";